/**
 * 分享成功页面
 * @author PJ
 */
import {
  Device,
 } from '@/utils';

import urlParam from 'url-param-object';

import {
  fetchVerificationCode,
  loginApp,
  fetchTickets,
} from '@/pages/Application/api';

import { HeaderBar } from '@/components';

const H5DeviceId = Device.getDeviceId();

export default {
  data() {
    return {
      title: '无人货架“蜂”狂来袭',
      /**
       * 1-分享成功，并且有用户信息
       * 2-分享成功，但是没有用户信息
       * 3-已经领取过优惠券
       * 4-通过输入手机号领取成功
       */
      userStatus: 1,
      token: '',
      userPhone: '',

      setInterval: null,

      isSendCode: false,
      isRequesting: false,
      // 活动已结束
      isOver: false,
      isLoading: true,

      seconds: 60,

      telephone: '',
      verificationCode: '',
      deviceId: Device.getId(),
    };
  },
  computed: {
    successTitle() {
      let title = '';
      switch (this.userStatus) {
        case 1:
          title = '分享成功';
          break;
        case 2:
          title = '分享成功，请领取优惠券';
          break;
        case 3:
          title = '本周您已通过分享领取过优惠券啦！';
          break;
        case 4:
          title = '领取成功';
          break;
        case 5:
          title = '领取失败';
          break;
        default:
          break;
      }
      return title;
    },

    successDes() {
      let des = '';
      switch (this.userStatus) {
        case 1:
        case 4:
          des = '优惠券已到账，请前往「便利蜂APP-我的」或「便利蜂小程序 - 我的」查看';
          break;
        case 2:
          des = '';
          break;
        case 3:
          des = '请前往「便利蜂APP-我的」或「便利蜂小程序-我的」查看';
          break;
        default:
          break;
      }
      return des;
    },
  },

  components: {
    HeaderBar,
  },

  methods: {
    onBackEvent() {
      this.$router.go(-1);
    },

    onStopPropagation(e) {
      e.stopPropagation();
    },

    onGet() {
      if (!this.verifyForm()) {
        return false;
      }
      if (!this.verificationCode.trim()) {
        this.showToast('请输入验证码', '10em');
        return false;
      }
      this.loginApp();
      return true;
    },

    showToast(text, width = '16em') {
      this.$vux.toast.show({
        position: 'middle',
        type: 'text',
        width,
        text,
      });
    },

    clearInterval() {
      this.seconds = 60;
      this.isSendCode = false;
      if (this.setInterval) {
        clearInterval(this.setInterval);
        this.setInterval = null;
      }
    },

    countDown() {
      this.setInterval = setInterval(() => {
        this.seconds = this.seconds - 1;
        if (this.seconds <= 0) {
          this.clearInterval();
        }
      }, 1000);
    },

    verifyForm() {
      if (this.telephone.trim() === '') {
        this.showToast('请输入手机号', '10em');
        return false;
      }
      if (!/^(13|15|18|14|17)\d{9}$/.test(this.telephone)) {
        this.showToast('手机号不正确', '10em');
        return false;
      }
      return true;
    },

    getSuccess(type) {
      // 一开始就获取到了用户token
      if (type === 1) {
        this.userStatus = 1;
        return;
      }
      // 通过手动输入手机号领取
      if (type === 2) {
        this.userStatus = 4;
      }
      this.clearInterval();
    },

    // 登陆
    loginApp() {
      if (!this.verifyForm()) {
        return;
      }
      if (this.verificationCode === '') {
        this.showToast('验证码为空', '10em');
        return;
      }
      this.isRequesting = true;
      loginApp(
        {
          mobilePhone: this.telephone,
          smsVerifyCode: this.verificationCode,
        },
        {
          deviceid: H5DeviceId,
        },
      ).then((res) => {
        this.isRequesting = false;
        if (res.status !== 0) {
          this.verificationCode = '';
          this.showToast(res.msg, '15em');
          return false;
        }
        const data = res.data || {};
        this.token = data.token;
        this.deviceId = data.deviceId;
        this.$store.dispatch('SET_USERPHONE', this.telephone);
        this.$store.dispatch('SET_USERINFO', data);
        this.fetchTickets(2, {
          token: data.token,
          deviceId: data.deviceId,
        });
        return true;
      });
      setTimeout(() => {
        this.isRequesting = false;
      }, 5000);
    },

    // 获取验证码
    fetchVerificationCode() {
      if (!this.verifyForm()) {
        return;
      }
      this.isSendCode = true;
      this.countDown();
      fetchVerificationCode(
        {
          mobilePhone: this.telephone,
          verifyCodeType: 'MOBILE_LOGIN',
        },
        {
          deviceid: H5DeviceId,
        },
      ).then((res) => {
        if (res.status !== 0) {
          this.showToast(res.msg, '10em');
          return false;
        }
        return true;
      });
    },

    // 领取优惠券
    fetchTickets(type, param) {
      fetchTickets(
        {
          mappingFlag: 'W3xCCmyhHL6ToJ',
        },
        {
          token: param.token,
          deviceid: param.deviceId,
        },
      ).then((res) => {
        this.isLoading = false;
        // 已经领取过优惠券
        if (res.status === 110000) {
          this.userStatus = 3;
          return false;
        }

        // 活动已经结束
        if (res.status === 110003) {
          this.isOver = true;
          return false;
        }
        this.isOver = false;
        if (res.status !== 0) {
          this.verificationCode = '';
          this.userStatus = 5;
          this.showToast(res.msg, '16em');
          return false;
        }

        this.getSuccess(type);
        return true;
      });
    },

    initData() {
      this.clearInterval();
      let deviceId = this.$store.state.deviceId;

      if (!deviceId) {
        deviceId = urlParam.getParamValue('deviceId');
      }

      if (!deviceId) {
        deviceId = Device.getId();
      }

      this.token = this.$store.state.token || urlParam.getParamValue('token');
      this.deviceId = deviceId;
      // 如果token存在，则直接领取优惠券
      if (this.token) {
        this.fetchTickets(1, {
          token: this.token,
          deviceId: this.deviceId,
        });
        return true;
      }
      // 不存在token，则需要手动输入手机号
      this.userStatus = 2;
      this.isLoading = false;
      return false;
    },
  },

  mounted() {
    this.initData();
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/components/ShareSuccess/main.js